import DashboardYtdController from './ytd';

export default class DashboardRufController extends DashboardYtdController {}
